define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  
  return Backbone.Model.extend({
    urlRoot: '/delegate/civics-api/api/portal/favorites/contact',

    url: function() {
      
      if(this.id){
        return this.urlRoot + "/" + this.id;

      }
      return this.urlRoot;

    },
  });
});

